import { createComponent } from '@lit/react';
import React from 'react';
import { SDSAlert } from '../sds-alert/sds-alert';
import { SheriffEventName } from './types';

export const SDSAlertWrapper = createComponent({
	tagName: 'sds-alert',
	elementClass: SDSAlert,
	react: React,
	events: {
		onRemove: 'sds-remove' as SheriffEventName,
	},
});
